<script setup lang="ts">

import { ref } from "vue";

import SeasonRank from "./SeasonRank.vue";
import ExpRank from "./ExpRank.vue";
const curTab = ref('mmr')

const seasonRank = ref()
const expRank = ref()

const showResult = ref(false);
function open() {
  showResult.value = true;
  seasonRank.value?.refreshData()
  expRank.value?.refreshData()
}
defineExpose({
  open,
  close
})

function close() {
  showResult.value = false;
}
</script>
<template>
  <el-dialog v-model="showResult" width="100%" style="max-width: 500px">
    <div class="rank-page">
      <el-tabs v-model="curTab" stretch>
        <el-tab-pane label="积分榜" name="mmr" class="pane" lazy>
          <SeasonRank ref="seasonRank" class="pane-item" />
        </el-tab-pane>
        <el-tab-pane label="经验榜" name="exp" class="pane" lazy>
          <ExpRank ref="expRank" class="pane-item" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>
<style lang="scss" scoped>
.rank-page {
  display: flex;
  flex-flow: column nowrap;
  padding-top: 0;

  .el-tabs {
    flex: 1;
    display: flex;
    flex-flow: column nowrap;
    overflow: hidden;
  }

  :deep() {
    .el-tabs__content {
      flex: 1;

      .pane {
        height: 100%;
        overflow: hidden;

        .pane-item {
          height: 100%;
          overflow: hidden;
          display: flex;
          flex-flow: column nowrap;
        }
      }
    }
  }
}
</style>